import { useEffect } from 'react';
import { site } from '../content/site';

/**
 * Reproduces the rule the old _Layout.cshtml used: bare brand on the home page,
 * "{Title} - Courtney.care" everywhere else.
 */
export function useDocumentTitle(title?: string): void {
  useEffect(() => {
    document.title = title ? `${title} - ${site.name}` : site.name;
  }, [title]);
}
